import Queries from "../Components/Querys/Querys";

const QuerysPage = () => {
  return (
    <div>
      <Queries />
    </div>
  );
};

export default QuerysPage;
